/* eslint-disable consistent-return */
import { useState, useEffect } from "react";
import PropTypes from "prop-types";

import DropdownWithMultiCtrlledRemovable from "@shared/DropdownWithMultiCtrlledRemovable";
import CustomOptionMultiAgent from "./CustomOptionMultiAgent";

const ALL_OPTION = { label: "All Team Members", value: "all" };

const DropdownSelectMultiAgents = ({ agents, selectedAgentsIds, setSelectedAgents }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    if (agents.length) {
      setSelectedOptions(selectedAgentsIds?.map((id) => agents.find((item) => item.value === id)));
    }
  }, [selectedAgentsIds, agents]);

  const setSelectedAgentsHandlr = (options) => {
    const selectedIds = options?.map((option) => option.value);

    if (JSON.stringify(selectedIds) !== JSON.stringify(selectedAgentsIds)) {
      setSelectedAgents(selectedIds);
    }
  };

  return (
    <DropdownWithMultiCtrlledRemovable
      options={agents}
      selectedOptions={selectedOptions}
      eventListenerId={null}
      onChange={(v) => {
        if (!agents.length) {
          return [];
        }

        const selectedAll = selectedOptions?.find((option) => option.value === "all");

        if (!v.length) {
          return setSelectedOptions(() => {
            const defaultValue = selectedAll ? [agents.find((agent) => agent.currentUser)] : [ALL_OPTION];

            setSelectedAgentsHandlr(defaultValue);
            return defaultValue;
          });
        }

        if (selectedAll && !v.length) {
          return;
        }

        if (!selectedAll && v.find((option) => option.value === "all")) {
          return setSelectedOptions(() => {
            setSelectedAgentsHandlr([ALL_OPTION]);
            return [ALL_OPTION];
          });
        }

        if (selectedAll && v[v.length - 1].value !== "all") {
          return setSelectedOptions(() => {
            const filteredValues = v.filter((option) => option.value !== "all");
            setSelectedAgentsHandlr(filteredValues);
            return filteredValues;
          });
        }

        return setSelectedOptions(() => {
          setSelectedAgentsHandlr(v);
          return v;
        });
      }}
      dropdownMultiValueClassName="!tw-hidden"
      OptionComponent={CustomOptionMultiAgent}
      placeholder={
        <div className="tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis tw-max-w-[467px]">
          {selectedAgentsIds?.map((id) => agents?.find((item) => item.value === id)?.label).join(", ")}
        </div>
      }
    />
  );
};

export default DropdownSelectMultiAgents;

DropdownSelectMultiAgents.propTypes = {
  selectedAgentsIds: PropTypes.arrayOf(PropTypes.string),
  setSelectedAgents: PropTypes.func,
  agents: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

DropdownSelectMultiAgents.defaultProps = {
  selectedAgentsIds: [],
  setSelectedAgents: () => {},
};
